export const environment = {
  appVersion: require("../../package.json").version,
  production: true,
  baseHref: "",
  timeStamp: "01/07/2025 11:21:52 AM EST",
  clientId: "ZnTmhRQa3NHj0wikHigzpBksYjOiSk0I",
  connection: "accc",
  organization: "accc",
  firebase: {
    apiKey: "AIzaSyAgIZtLBQVFAewI9ILJ55POwXcl4He7rG4",
    authDomain: "medicnow-1fd29.firebaseapp.com",
    projectId: "medicnow-1fd29",
    storageBucket: "medicnow-1fd29.appspot.com",
    messagingSenderId: "59209117542",
    appId: "1:59209117542:web:f6978140f161f529b3a2a7",
    measurementId: "G-2RQ5MGLVRG",
  },
  apiUrl: "https://api-qa.medicnowsolutions.com",
  awsS3Url: "https://sandbox-medicnow-app.s3.us-east-1.amazonaws.com",
};
